import axiosInstance from '../axiosInstance';

export const requestKnameDownload = async (blob, selection) => {
  const form = new FormData();
  form.append('file', blob, 'card.png');
  form.append('nameId', selection.name.id);
  form.append('nameRoman', selection.name.romanization);
  const response = await axiosInstance.post('/kname/cards', form);
  return response.data.data;
};
